const actionTypes = Object.freeze({
  CREATE_APPROVER: 'CREATE_APPROVER',
  UPDATE_APPROVER: 'UPDATE_APPROVER',
  LOAD_APPROVERS: 'LOAD_APPROVERS',

  CREATE_GAME: 'CREATE_GAME',
  UPDATE_GAME: 'UPDATE_GAME',
  LOAD_GAMES: 'LOAD_GAMES',
  ARCHIVE_GAME: 'ARCHIVE_GAME',
  UNARCHIVE_GAME: 'UNARCHIVE_GAME',

  GAME_UPLOAD_FAILURE: 'GAME_UPLOAD_FAILURE',
  GAME_UPLOAD_CLEAR: 'GAME_UPLOAD_CLEAR',

  CREATE_KEYPROVIDER: 'CREATE_KEYPROVIDER',
  UPDATE_KEYPROVIDER: 'UPDATE_KEYPROVIDER',
  LOAD_KEYPROVIDERS: 'LOAD_KEYPROVIDERS',
  DELETE_KEYPROVIDER: 'DELETE_KEYPROVIDER',

  CREATE_PACKAGETYPE: 'CREATE_PACKAGETYPE',
  UPDATE_PACKAGETYPE: 'UPDATE_PACKAGETYPE',
  LOAD_PACKAGETYPES: 'LOAD_PACKAGETYPES',
  DELETE_PACKAGETYPE: 'DELETE_PACKAGETYPE',

  CREATE_PLATFORM: 'CREATE_PLATFORM',
  UPDATE_PLATFORM: 'UPDATE_PLATFORM',
  LOAD_PLATFORMS: 'LOAD_PLATFORMS',
  DELETE_PLATFORM: 'DELETE_PLATFORM',

  CREATE_TERRITORY: 'CREATE_TERRITORY',
  UPDATE_TERRITORY: 'UPDATE_TERRITORY',
  LOAD_TERRITORIES: 'LOAD_TERRITORIES',
  DELETE_TERRITORY: 'DELETE_TERRITORY',

  LOAD_CURRENCIES: 'LOAD_CURRENCIES',

  CREATE_WORKFLOW: 'CREATE_WORKFLOW',
  UPDATE_WORKFLOW: 'UPDATE_WORKFLOW',
  LOAD_WORKFLOWS: 'LOAD_WORKFLOWS',
  DELETE_WORKFLOW: 'DELETE_WORKFLOW',

  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',

  BIG_LOADER_SHOW: 'BIG_LOADER_SHOW',
  BIG_LOADER_HIDE: 'BIG_LOADER_HIDE',

  LAYOUT_CLOSE_NAV_MENU: 'LAYOUT_CLOSE_NAV_MENU',
  LAYOUT_OPEN_NAV_MENU: 'LAYOUT_OPEN_NAV_MENU',
  LAYOUT_TOGGLE_NAV_MENU: 'LAYOUT_TOGGLE_NAV_MENU',

  CREATE_DISABLEREASON: 'CREATE_DISABLEREASON',
  UPDATE_DISABLEREASON: 'UPDATE_DISABLEREASON',
  LOAD_DISABLEREASONS: 'LOAD_DISABLEREASONS',
  DELETE_DISABLEREASON: 'DELETE_DISABLEREASON',

  USER_SIGNED_IN: 'auth/userSignedIn',
  ADD_TO_GROUP: 'signalR/addToGroup',
  REMOVE_FROM_GROUP: 'signalR/removeFromGroup',
  GET_CONNECTED_USERS: 'signalR/getConnectedUsers',
  PAGE_ACTIVE: 'signalR/pageActive',
  PAGE_INACTIVE: 'signalR/pageInactive',

  UPDATE_STEAMREQUEST: 'UPDATE_STEAMREQUEST',
  CLEAR_STEAMREQUEST: 'CLEAR_STEAMREQUEST',

  UPDATE_SOLD_TRANSACTION: 'UPDATE_SOLD_TRANSACTION',
  CLEAR_SOLD_TRANSACTION: 'CLEAR_SOLD_TRANSACTION',

  UPDATE_MOVE_TRANSACTION: 'UPDATE_MOVE_TRANSACTION',
  CLEAR_MOVE_TRANSACTION: 'CLEAR_MOVE_TRANSACTION',

  UPDATE_IMPORT_TRANSACTION: 'UPDATE_IMPORT_TRANSACTION',
  CREATE_IMPORT_TRANSACTION: 'CREATE_IMPORT_TRANSACTION',
  DELETE_IMPORT_TRANSACTION: 'DELETE_IMPORT_TRANSACTION',
});

export default actionTypes;
